<form *ngIf="form" [formGroup]="form">
	<ion-grid *ngIf="dynamicFormControls">
		<app-dynamic-form-control
			*ngFor="let formControl of dynamicFormControls"
			[dynamicFormControl]="formControl"
			[primaryKeys]="primaryKeys"
			[form]="form"
			lines="none"
		></app-dynamic-form-control>
	</ion-grid>
</form>

<ion-footer class="ion-no-border">
	<ion-fab horizontal="end" vertical="bottom" class="ion-margin">
		<ion-fab-button type="submit" appThrottleButtonDirective (eventTriggered)="onSubmit()" [throttleTime]="2000">
			<ion-icon class="icon-Save"></ion-icon>
		</ion-fab-button>
	</ion-fab>
</ion-footer>
